import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import FlexContentHandler from 'components/shared/FlexContentHandler'

interface PageProps {
  data: {
    page: {
      title?: string
      path?: string
      seo: any
      flexContent: any
    }
  }
  location?: any
}

const PageTemplate: React.FC<PageProps> = ({
  data: {
    page: { flexContent, seo },
  },
  location = {},
}) => {
  let theme: string = 'solid-orange'

  const banner =
    Array.isArray(flexContent.flex) &&
    flexContent.flex[0].fieldGroupName.includes('Banner')

  if (banner) {
    theme = 'transparent-npmorange'
  }

  return (
    <Layout theme={theme}>
      <SEO seo={seo} />
      <FlexContentHandler fields={flexContent} location={location} />
    </Layout>
  )
}

export const pageQuery = graphql`
  query pageById($id: String!) {
    page: wpPage(id: { eq: $id }) {
      ...generalPageFragment
    }
  }
`

export default PageTemplate
